// Mini système de toasts (pub/sub) — appelable depuis n'importe où :
//   import { toast } from "../components/toast";
//   toast.success("Email envoyé"); toast.error("Échec");
let listeners = [];
let counter = 0;

export function toast(message, variant = "success") {
  const item = { id: ++counter, message, variant };
  listeners.forEach((l) => l(item));
}
toast.success = (m) => toast(m, "success");
toast.error = (m) => toast(m, "error");

export function subscribeToasts(fn) {
  listeners.push(fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
  };
}
